// Silent-refresh scheduling shared by the Google ID token (AuthProvider) and
// the admin STS credentials (AdminProvider): renew this many ms before expiry,
// but never schedule the timer sooner than the floor when the credential is
// already near or at expiry.
export const REFRESH_SKEW_MS = 5 * 60 * 1000
export const MIN_REFRESH_DELAY_MS = 10_000

// Delay from now until the silent refresh should fire, given an absolute
// expiry time in epoch ms.
export function refreshDelayMs(expiresAtMs: number): number {
  return Math.max(MIN_REFRESH_DELAY_MS, expiresAtMs - Date.now() - REFRESH_SKEW_MS)
}
